import { DataBean } from "../DataBean";

export class SIIFTCON6Valuetwo extends DataBean {

    public async getSIIFTCON6ValueCatalog(idSIIFAuxiliary: any, idSIIFTCON17Value: any, accountantIDStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getSIIFTCON6ValueCatalog_Number_Number_String_Number_Number", [idSIIFAuxiliary, idSIIFTCON17Value, accountantIDStr, page, recordsPerPage]);
    }

}